import CONFIG from '@config';

const getPlatform = () => {
  return CONFIG.algolia?.platform?.cms || 'unknown-platform';
};

export default getPlatform;
